import { render, staticRenderFns } from "./SearchItem.vue?vue&type=template&id=7a37a1c4"
import script from "./SearchItem.vue?vue&type=script&lang=js"
export * from "./SearchItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports